import { render, staticRenderFns } from "./InventoryNewItemOverlay.vue?vue&type=template&id=39b10f1e&"
import script from "./InventoryNewItemOverlay.vue?vue&type=script&lang=ts&"
export * from "./InventoryNewItemOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports